export default __webpack_public_path__ + "static/media/jolt-100-8.fee592e0.jpg";